import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Accordion,
  Form,
  Modal,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { MdDeleteOutline } from "react-icons/md";
import moment from "moment";
import {
  FaEnvelope, FaEye, FaWhatsapp,
  FaFileAlt,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaCalendarCheck, FaEdit
} from "react-icons/fa";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import {
  getLead,
  getLeadActivity,
  addLeadActivity,
} from "../../store/slices/leads";
import { addBooking } from "../../store/slices/booking";
import { getQuotation, resendQuotation, deleteQuotation } from "../../store/slices/quotation";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

export default function LeadDetails() {
  const [tab, setTab] = useState("overview");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [leadData, setLeadData] = useState([]);
  const [activityType, setActivityType] = useState("NOTE");
  const [activities, setActivities] = useState([]);
  const [quotations, setQuotations] = useState([]);
  const [quotationCount, setQuotationCount] = useState(0);

  const [showBookingModal, setShowBookingModal] = useState(false);
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [selectedOptionId, setSelectedOptionId] = useState("");
  const [bookingDiscount, setBookingDiscount] = useState(0);

  const selectedOption = selectedQuotation?.options?.find(
    (opt) => opt._id === selectedOptionId
  );

  useEffect(() => {
    const fetchLead = async () => {
      try {
        const res = await dispatch(getLead({ id })).unwrap();
        const leads = res?.leads[0] || [];

        console.log(res.leads);

        setLeadData(leads);
      } catch (error) {
        console.error(error);
      }
    };

    fetchLead();
  }, [dispatch, id]);

  useEffect(() => {
    const fetchQuotations = async () => {
      try {
        const res = await dispatch(getQuotation({ leadId: id })).unwrap();
        setQuotations(res?.data || []);
        setQuotationCount(res?.count || 0);
      } catch (error) {
        console.error(error);
      }
    };

    if (id) fetchQuotations();
  }, [dispatch, id]);

  const handleDeleteQuotation =
    async (quotationId) => {

      try {

        await dispatch(
          deleteQuotation(quotationId)
        ).unwrap();

        setQuotations((prev) =>
          prev.filter(
            (q) => q._id !== quotationId
          )
        );

        setQuotationCount((prev) =>
          prev > 0 ? prev - 1 : 0
        );

        toast.success(
          "Quotation deleted successfully"
        );

      } catch (error) {

        console.error(error);

        toast.error(
          error ||
          "Failed to delete quotation"
        );

      }
    };

  const handleResend = async (quotationId) => {
    try {
      await dispatch(resendQuotation({ quotationId })).unwrap();

      toast.success("Quotation resent successfully");
    } catch (error) {
      console.error(error);
      toast.error("Failed to resend quotation");
    }
  };

  const handleWhatsAppShare = (quotation) => {
    const customerName = leadData?.name || "Customer";

    const quotationNumber =
      quotation?.quotationNumber || "";

    const amount =
      quotation?.options?.[0]?.totalAmount || 0;

    let phone =
      leadData?.phone?.replace(/\D/g, "") || "";

    // Add India country code if missing
    if (phone.length === 10) {
      phone = `91${phone}`;
    }

    const shortUrl =
      `https://api.dwellium.in/q/${quotation?.quotationNumber}`;

    const message =
      `Hi ${customerName},

Your travel quotation (${quotationNumber}) is ready ✈️

Quotation Amount: ₹${amount.toLocaleString()}

View Quotation:
${shortUrl}

Thank you for choosing us 😊`;

    const whatsappUrl =
      `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank");
  };

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        const res = await dispatch(getLeadActivity({ leadId: id })).unwrap();

        setActivities(res.activities || []);
      } catch (error) {
        console.error(error);
      }
    };

    if (id) fetchActivities();
  }, [dispatch, id]);

  const [showLogActivity, setShowLogActivity] = useState(false);
  const [note, setNote] = useState("");

  // 🔹 Total Quoted Amount
  const totalQuotedAmount = quotations.reduce((sum, q) => {
    const amount = q.options?.[0]?.totalAmount || 0;
    return sum + amount;
  }, 0);

  // 🔹 Conversations Count Breakdown
  const activityCounts = activities.reduce(
    (acc, item) => {
      if (item.type === "EMAIL") acc.email++;
      else if (item.type === "CALL") acc.call++;
      else if (item.type === "FOLLOW_UP") acc.followUp++;
      else acc.note++;
      return acc;
    },
    { email: 0, call: 0, followUp: 0, note: 0 },
  );

  const totalConversations =
    activityCounts.email +
    activityCounts.call +
    activityCounts.followUp +
    activityCounts.note;

  // 🔹 Days in Pipeline
  const createdDate = leadData?.createdAt ? new Date(leadData.createdAt) : null;

  const today = new Date();

  const daysInPipeline = createdDate
    ? Math.floor((today - createdDate) / (1000 * 60 * 60 * 24))
    : 0;

  const ovStatsData = [
    {
      title: "Total Quoted",
      value: `₹${totalQuotedAmount.toLocaleString()}`,
      sub: `Across ${quotationCount} proposal${quotationCount !== 1 ? "s" : ""}`,
      color: "ov-orange",
    },
    {
      title: "Conversations",
      value: totalConversations,
      sub: `${activityCounts.email} email · ${activityCounts.call} call · ${activityCounts.note} note`,
      color: "ov-blue",
    },
    {
      title: "Days in Pipeline",
      value: daysInPipeline,
      sub: createdDate
        ? `Since ${moment(createdDate).format("DD-MM-YYYY")}`
        : "",
      color: "ov-purple",
    },
  ];
  const handleSaveActivity = async () => {
    try {
      if (!note.trim()) {
        toast.error("Please enter a note");
        return;
      }

      const payload = {
        lead: id,
        type: activityType,
        description: note,
      };

      await dispatch(addLeadActivity(payload)).unwrap();

      toast.success("Activity logged successfully");

      // Reset UI
      const res = await dispatch(getLeadActivity({ leadId: id })).unwrap();
      setActivities(res.activities || []);

      setNote("");
      setShowLogActivity(false);
    } catch (error) {
      console.error(error);
      toast.error(error || "Failed to log activity");
    }
  };
  const openBookingModal = (quotation) => {
    setSelectedQuotation(quotation);
    setSelectedOptionId("");
    setBookingDiscount(0);
    setShowBookingModal(true);
  };
  const handleConfirmBooking = async () => {
    try {
      if (!selectedOptionId) {
        toast.error("Please select an option");
        return;
      }

      const selectedOption = selectedQuotation?.options?.find(
        (opt) => opt._id === selectedOptionId
      );

      if (
        Number(bookingDiscount || 0) >
        Number(selectedOption?.totalAmount || 0)
      ) {
        toast.error(
          `Discount cannot exceed ₹${selectedOption.totalAmount?.toLocaleString()}`
        );
        return;
      }

      const payload = {
        quotationId: selectedQuotation._id,
        optionId: selectedOptionId,
        bookingDiscount: Number(bookingDiscount || 0),
      };

      const data = await dispatch(addBooking(payload)).unwrap();

      if (!data?.success) {
        throw new Error(data?.message || "Booking failed");
      }

      toast.success("Booking created successfully 🎉");

      setShowBookingModal(false);
    } catch (err) {
      console.error(err);
      toast.error(err?.message || "Failed to create booking");
    }
  };
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/hote/home" className="breadcrumb-link active">
            Home
          </Link>
          <span className="breadcrumb-separator"> | </span>
          <Link to="/admin/lead" className="breadcrumb-link active">
            Leads
          </Link>
          <span className="breadcrumb-separator"> | </span>
          <span className="breadcrumb-link inactive">Lead Details</span>
        </div>
      </div>

      <Container fluid className="lead-container">
        <Row>
          <Col lg={4} md={12}>
            <Card className="profile-card" style={{ border: "none" }}>
              <div className="avatar">{leadData?.name?.charAt(0)}</div>

              <h4 className="name">{leadData?.name}</h4>

              <p className="designation">{leadData?.email || "email"}</p>

              <div className="tags">
                <span>{leadData?.status}</span>
                <span>{leadData?.priority}</span>
              </div>

              <hr />

              <div className="details">
                <div>
                  <span>Source</span>
                  <b>{leadData?.source}</b>
                </div>
                <div>
                  <span>Agent</span>
                  <b>{leadData?.agentId?.name}</b>
                </div>

                <div>
                  <span>Created</span>
                  <b>
                    {leadData?.createdAt
                      ? moment(leadData.createdAt).format("DD-MM-YYYY")
                      : ""}
                  </b>
                </div>

                <div>
                  <span>Travel Date</span>
                  <b>
                    {leadData?.tentativeTravelDate
                      ? moment(leadData.tentativeTravelDate).format("DD-MM-YYYY")
                      : ""}
                  </b>
                </div>
                <div>
                  <span>Budget</span>
                  <b>₹{leadData?.budget}</b>
                </div>
                <div>
                  <span>Pax</span>
                  <b>
                    {leadData?.adults} Adult{leadData?.adults > 1 ? "s" : ""}{" "}
                    {leadData?.children > 0 &&
                      `${leadData.children} ${leadData.children === 1 ? "Child" : "Children"}`}
                  </b>
                </div>
              </div>
            </Card>

            {/* contact card <----- */}

            <Card className="contact-card" style={{ border: "none" }}>
              <p className="label">Contact Details</p>

              <div className="contact-item">
                <FaEnvelope style={{ color: "#5c2fda" }} />
                {leadData?.email}
              </div>

              <div className="contact-item">
                <FaPhoneAlt style={{ color: "#47db64" }} />
                {leadData?.phone}
              </div>

              <div className="contact-item">
                <FaMapMarkerAlt style={{ color: "#c87b29" }} />
                {leadData?.country}
              </div>
            </Card>
          </Col>

          <Col lg={8} md={12}>
            <div className="top-tabs">
              <Row className="mb-3">
                <Col>
                  <div
                    className="my-2"
                    style={{
                      display: "flex",
                      background: "#f3f4f6",
                      padding: "6px",
                      borderRadius: "16px",
                      width: "100%",
                      maxWidth: "420px",
                    }}
                  >
                    <button
                      onClick={() => setTab("overview")}
                      style={{
                        flex: 1,
                        padding: "8px 12px",
                        border: "none",
                        borderRadius: "12px",
                        background:
                          tab === "overview" ? "#1E0959" : "transparent",
                        color: tab === "overview" ? "#fff" : "#374151",
                        fontWeight: 500,
                        fontSize: "14px",
                        transition: "0.2s",
                      }}
                    >
                      Overview
                    </button>

                    <button
                      onClick={() => setTab("quotations")}
                      style={{
                        flex: 1,
                        padding: "8px 12px",
                        border: "none",
                        borderRadius: "12px",
                        background:
                          tab === "quotations" ? "#1E0959" : "transparent",
                        color: tab === "quotations" ? "#fff" : "#374151",
                        fontWeight: 500,
                        fontSize: "14px",
                        transition: "0.2s",
                      }}
                    >
                      Quotations
                    </button>

                    <button
                      onClick={() => setTab("conversations")}
                      style={{
                        flex: 1,
                        padding: "8px 12px",
                        border: "none",
                        borderRadius: "12px",
                        background:
                          tab === "conversations" ? "#1E0959" : "transparent",
                        color: tab === "conversations" ? "#fff" : "#374151",
                        fontWeight: 500,
                        fontSize: "14px",
                        transition: "0.2s",
                      }}
                    >
                      Conversations
                    </button>
                  </div>
                </Col>
              </Row>
            </div>

            {tab === "overview" && (
              <>
                <Row className="ov-stats-row">
                  {ovStatsData.map((item, index) => (
                    <Col lg={4} md={6} key={index} className="my-2">
                      <div className="ov-stat-card">
                        <div className="ov-stat-title">{item.title}</div>

                        <div className={`ov-stat-value ${item.color}`}>
                          {item.value}
                        </div>

                        <div className="ov-stat-sub">{item.sub}</div>
                      </div>
                    </Col>
                  ))}
                </Row>

                <div className="ov-activity-card">
                  <div className="ov-activity-header">Recent Activity</div>

                  {activities.length === 0 && (
                    <div
                      style={{
                        padding: "20px",
                        textAlign: "center",
                        color: "#999",
                      }}
                    >
                      No recent activity
                    </div>
                  )}

                  {activities.slice(0, 5).map((item, index) => {
                    const getIcon = () => {
                      switch (item.type) {
                        case "CALL":
                          return <FaPhoneAlt />;
                        case "EMAIL":
                          return <FaEnvelope />;
                        case "FOLLOW_UP":
                          return <FaCalendarCheck />;
                        default:
                          return <FaFileAlt />;
                      }
                    };

                    const getTypeClass = () => {
                      switch (item.type) {
                        case "CALL":
                          return "ov-call";
                        case "EMAIL":
                          return "ov-email";
                        case "FOLLOW_UP":
                          return "ov-follow";
                        default:
                          return "ov-note";
                      }
                    };

                    return (
                      <div className="ov-activity-row" key={item._id}>
                        <div className="ov-activity-icon-area">
                          <div className={`ov-icon-circle ${getTypeClass()}`}>
                            {getIcon()}
                          </div>

                          {index !== activities.slice(0, 5).length - 1 && (
                            <div className="ov-vertical-line"></div>
                          )}
                        </div>

                        <div className="ov-activity-content">
                          <div className="ov-activity-title">
                            {item.type.replace("_", " ")}
                          </div>

                          <div className="ov-activity-text">
                            {item.description}
                          </div>
                        </div>

                        <div className="ov-activity-time">
                          {moment(item.createdAt).format("DD-MM-YYYY")}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {tab === "quotations" && (
              <>
                <div className="qt-header">
                  <div className="qt-count">
                    {quotationCount} quotation{quotationCount !== 1 ? "s" : ""}{" "}
                    sent
                  </div>
                  {leadData?.status !== "Booked" && (
                    <Link to={`/admin/create-quotation/${id}`}>
                      <button className="submit-btn p-1 qt-create-btn">
                        + Create Quotation
                      </button>
                    </Link>
                  )}
                </div>

                {quotations.map((item, index) => {
                  const amount = item.options?.[0]?.totalAmount || 0;
                  const date = item.createdAt
                    ? moment(item.createdAt).format("DD-MM-YYYY")
                    : "-";

                  return (
                    <div className="qt-card" key={index}>
                      {/* LEFT */}
                      <div className="qt-left">
                        <div className="qt-top">
                          <div className="qt-id">{item.quotationNumber}</div>
                          <div
                            className={`qt-status-badge ${item.statusClass}`}
                          >
                            {item.status}
                          </div>
                        </div>

                        <div className="qt-title">{item.package?.title}</div>

                        <div className="qt-meta">
                          <span>📅 {date}</span>
                          <span>
                            👥 {item.numberOfAdults || 0}A +{" "}
                            {item.numberOfChildren || 0}C
                          </span>
                          <span>🧍 {item.totalPax || 0} Pax</span>
                        </div>
                      </div>

                      {/* RIGHT */}
                      <div className="qt-right">
                        <div className="qt-price">
                          ₹{amount.toLocaleString()}
                        </div>
                        {leadData?.status !== "Booked" && (
                          <>
                            <div className="qt-actions">
                              <button
                                className="qt-btn view"
                                onClick={() =>
                                  navigate(`/admin/quotation/${item._id}/preview`)
                                }
                              >
                                <FaEye />
                              </button>
                              <button
                                className="qt-btn"
                                style={{
                                  background: "#dcfce7",
                                  color: "#16a34a",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px"
                                }}
                                onClick={() =>
                                  handleWhatsAppShare(item)
                                }
                              >
                                <FaWhatsapp />
                                WhatsApp
                              </button>
                              <Link
                                className="qt-btn edit"
                                to={`/admin/edit-quotation/${item._id}`}
                              >
                                <FaEdit />
                              </Link>
                              <button
                                className="qt-btn resend"
                                onClick={() => handleResend(item._id)}
                              >
                                <FaEnvelope />
                              </button>
                              <button
                                className="qt-btn book"
                                onClick={() => openBookingModal(item)}
                              >
                                Book
                              </button>
                              <button
                                className="qt-btn"
                                style={{
                                  background: "#fee2e2",
                                  color: "#dc2626",
                                }}
                                onClick={() =>
                                  handleDeleteQuotation(item._id)
                                }
                              >
                                <MdDeleteOutline style={{ fontSize: "16px" }} />
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
              </>
            )}

            {tab === "conversations" && (
              <>
                <div className="conversation-header">
                  <button
                    className="submit-btn"
                    onClick={() => setShowLogActivity(!showLogActivity)}
                  >
                    + Log Activity
                  </button>
                </div>

                {showLogActivity && (
                  <Card
                    style={{
                      marginTop: "16px",
                      borderRadius: "14px",
                      border: "1px solid #e5e7eb",
                      padding: "10px",
                    }}
                    className="my-2"
                  >
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      Add Note / Log Activity
                    </div>

                    <Form.Group>
                      <Form.Select
                        value={activityType}
                        onChange={(e) => setActivityType(e.target.value)}
                        style={{ marginBottom: "10px", borderRadius: "10px" }}
                      >
                        <option value="NOTE">Note</option>
                        <option value="CALL">Call</option>
                        <option value="EMAIL">Email</option>
                        <option value="FOLLOW_UP">Follow Up</option>
                      </Form.Select>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Add a note or summary about this interaction..."
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        style={{ borderRadius: "10px", fontSize: "14px" }}
                      />
                    </Form.Group>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "16px",
                        flexWrap: "wrap",
                      }}
                    >
                      <button
                        variant="light"
                        onClick={() => {
                          setShowLogActivity(false);
                          setNote("");
                        }}
                        style={{
                          width: "5rem",
                        }}
                        className="cancel-btn"
                      >
                        Cancel
                      </button>

                      <button
                        style={{ width: "5rem" }}
                        className="submit-btn"
                        onClick={handleSaveActivity}
                      >
                        Save
                      </button>
                    </div>
                  </Card>
                )}

                <Accordion className="cv-accordion">
                  {activities.length === 0 && (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#999",
                      }}
                    >
                      No activities yet
                    </div>
                  )}

                  {activities.map((item, index) => {
                    const getIcon = () => {
                      switch (item.type) {
                        case "CALL":
                          return <FaPhoneAlt />;
                        case "EMAIL":
                          return <FaEnvelope />;
                        case "FOLLOW_UP":
                          return <FaCalendarCheck />;
                        default:
                          return <FaFileAlt />;
                      }
                    };

                    const getColor = () => {
                      switch (item.type) {
                        case "CALL":
                          return "green";
                        case "EMAIL":
                          return "blue";
                        case "FOLLOW_UP":
                          return "yellow";
                        default:
                          return "gray";
                      }
                    };

                    return (
                      <Accordion.Item
                        eventKey={index.toString()}
                        key={item._id}
                        className="cv-card"
                      >
                        <Accordion.Header>
                          <div className="cv-row">
                            <div className={`cv-icon ${getColor()}`}>
                              {getIcon()}
                            </div>

                            <div className="cv-content">
                              <div className="cv-title-row">
                                <div className="cv-title">
                                  {item.type.replace("_", " ")}
                                </div>

                                <span className={`cv-tag cv-${getColor()}`}>
                                  {item.type}
                                </span>
                              </div>

                              <div className="cv-meta">
                                {item.createdBy?.name || "User"} ·{" "}
                                {moment(item.createdAt).format("DD-MM-YYYY")}
                              </div>

                              <div className="cv-preview">
                                {item.description}
                              </div>
                            </div>
                          </div>
                        </Accordion.Header>

                        <Accordion.Body>
                          <div className="cv-details-text">
                            {item.description}
                          </div>

                          {item.followUpDate && (
                            <div
                              style={{ marginTop: "10px", color: "#6b7280" }}
                            >
                              Follow-up:{" "}
                              {new Date(item.followUpDate).toLocaleString()}
                            </div>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    );
                  })}
                </Accordion>
              </>
            )}
          </Col>
        </Row>
      </Container>

      <Modal
        show={showBookingModal}
        onHide={() => setShowBookingModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Package Option</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedQuotation?.options?.map((opt) => (
            <div
              key={opt._id}
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "10px",
                padding: "12px",
                marginBottom: "10px",
                cursor: "pointer",
                background: selectedOptionId === opt._id ? "#eef2ff" : "#fff",
              }}
              onClick={() => setSelectedOptionId(opt._id)}
            >
              <div style={{ fontWeight: 600 }}>{opt.name}</div>

              <div style={{ fontSize: "14px", color: "#6b7280" }}>
                ₹{opt.totalAmount?.toLocaleString()}
              </div>


            </div>
          ))}

          {selectedQuotation?.options?.length === 0 && (
            <div style={{ textAlign: "center", color: "#999" }}>
              No options available
            </div>
          )}
          <Form.Group className="mt-0">


            <Form.Group className="mt-3">
              <Form.Label>Booking Discount (₹)</Form.Label>

              <Form.Control
                type="text"
                value={bookingDiscount}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 6);

                  if (
                    selectedOption &&
                    Number(value) > Number(selectedOption.totalAmount)
                  ) {
                    toast.error(
                      `Discount cannot exceed ₹${selectedOption.totalAmount?.toLocaleString()}`
                    );
                    return;
                  }

                  setBookingDiscount(value);
                }}
                placeholder="Enter discount amount"
                maxLength={6}
              />

              {selectedOption && (
                <small className="text-muted">
                  Selected Package Price: ₹{selectedOption.totalAmount?.toLocaleString()}
                </small>
              )}
            </Form.Group>
          </Form.Group>
        </Modal.Body>


        <Modal.Footer>
          <button
            type="button"
            className="cancel-btn"
            onClick={() => setShowBookingModal(false)}
          >
            Cancel
          </button>

          <button type="submit" className="submit-btn" onClick={handleConfirmBooking}>
            Confirm Booking
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
